//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import fileUpload from '@/components/file-upload'
import DivSpan from '@/components/DivSpan'
export default {
  components:{fileUpload,DivSpan},
  props:['supContactList'],
  methods:{
    changeShow(i){
      if(this.supContactList[i].cellShow){
        this.$set(this.supContactList[i],'cellShow',false);
        return;
      }
      this.$set(this.supContactList[i],'cellShow',true);
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/supplier/view/contact.vue